import { Customer } from '@commercetools/platform-sdk';
import { SignInForm, SignUpForm } from '@components';
import { Modal, Tabs } from 'gd-design-library';
import React, { useState } from 'react';

enum TabOptions {
    SIGN_IN = 0,
    SIGN_UP = 1
}

interface SignInModalProps {
    handleSignIn: (email: string, password: string) => Promise<void>;
    handleSignUp: (customer: Customer) => void;
    handleClose: () => void;
    open: boolean;
    isLoading: boolean;
    errorMessage?: string;
}

export const SignInModal: React.FC<SignInModalProps> = ({
  handleSignIn,
  handleSignUp,
  handleClose,
  open,
  isLoading,
  errorMessage
}) => {
  const [ activeTab, setActiveTab ] = useState(TabOptions.SIGN_IN);

  const handleTabChange = (index: number): void => {
    setActiveTab(index);
  };

  const tabs = [ {
    id: 'sign-in',
    label: 'Log In',
    content: <SignInForm onSignIn={ handleSignIn } showSignUpLink={ false } isLoading={ isLoading }/>
  }, {
    id: 'sign-up',
    label: 'Register',
    content: <SignUpForm onSignUp={ handleSignUp } isLoading={ isLoading } errorMessage={ errorMessage }/>
  } ];

  return (<Modal
    isOpen={ open }
    onClose={ handleClose }
    title='Log In / Register'
  >
    <Tabs
      onTabChange={ handleTabChange }
      tabs={ tabs }
      activeTab={ activeTab }
    />
  </Modal>);
};
